/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitRecoveryActivities} from '../api'

export const useMutationSubmitRecoveryActivities = createReactQueryMutationHook('submitRecoveryActivities', submitRecoveryActivities)
